import {
  filterRequisitionList,
  RequisitionStatus,
  ScreenHeader,
  TopBar,
  AppLayout,
  useFilters,
  useGetRequisitionsForLabQuery
} from 'prove-common'
import { RequisitionFilterTags } from '../components/requisition-filter-tags/RequisitionFilterTags'
import RequisitionsTable from './tables/RequisitionsTable'
import { AppLogo } from '../components/app-logo/AppLogo'
import { SideBarLayout } from '../components/side-bar-layout/SideBarLayout'

const SamplesScreen = () => {
  const { filters, setFilters, isFiltering } =
    useFilters<RequisitionStatus>('filterRequisitions')
  const {
    data: requisitions,
    isPending,
    isError,
    isSuccess,
    error
  } = useGetRequisitionsForLabQuery()
  const filteredRequisitionList = filterRequisitionList(
    requisitions ?? [],
    filters
  )
  return (
    <AppLayout
      sidebar={<SideBarLayout />}
      isLoading={isPending}
      isError={isError}
      isFullWidth={true}
      topBar={
        <TopBar
          logo={<AppLogo />}
          title='Samples'
          showNotificationBell={true}
          isProvePlan={false}
        />
      }
      error={error}
    >
      {isSuccess && (
        <>
          <ScreenHeader
            title='Samples'
            description={
              <p>Here are all the samples registered for your laboratory.</p>
            }
          />
          <RequisitionFilterTags
            filters={filters}
            setFilters={setFilters}
            isFiltering={isFiltering}
          />
          <RequisitionsTable
            data={filteredRequisitionList}
            isFiltering={isFiltering}
          />
        </>
      )}
    </AppLayout>
  )
}

export default SamplesScreen
